import { render, staticRenderFns } from "./Screen.vue?vue&type=template&id=9c73d90c&scoped=true&"
import script from "./Screen.vue?vue&type=script&lang=js&"
export * from "./Screen.vue?vue&type=script&lang=js&"
import style0 from "./Screen.vue?vue&type=style&index=0&id=9c73d90c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c73d90c",
  null
  
)

export default component.exports